export const isEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email.toLowerCase());
  };
  
  export const isPhone = (phone: string) => {
    const regex = /^(\+91[\s]?|91[\s]?|0)?[6-9]\d{9}$/;
    return regex.test(phone.toLowerCase());
  };
  